import { OperationReports } from "/react4xp/parts/operation-reports/operation-reports";

export default (props) => <OperationReports {...props} />
